/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getUserLabTestItems } from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import { getEntities as getOrganisms } from 'app/entities/organism/organism.reducer';
import { getEntities as getAntibiotics } from 'app/entities/antibiotic/antibiotic.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-organism-antibiotic-susceptibility.reducer';

export const PatientOrganismAntibioticSusceptibilityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const userLabTestItems = useAppSelector(state => state.userLabTestItem.entities);
  const organisms = useAppSelector(state => state.organism.entities);
  const antibiotics = useAppSelector(state => state.antibiotic.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const patientOrganismAntibioticSusceptibilityEntity = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.entity);
  const loading = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.loading);
  const updating = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.updating);
  const updateSuccess = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-organism-antibiotic-susceptibility${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUserLabTestItems({}));
    dispatch(getOrganisms({}));
    dispatch(getAntibiotics({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.zoneOfInhibition !== undefined && typeof values.zoneOfInhibition !== 'number') {
      values.zoneOfInhibition = Number(values.zoneOfInhibition);
    }
    if (values.mic !== undefined && typeof values.mic !== 'number') {
      values.mic = Number(values.mic);
    }
    if (values.mbc !== undefined && typeof values.mbc !== 'number') {
      values.mbc = Number(values.mbc);
    }
    if (values.testDate !== undefined && typeof values.testDate !== 'number') {
      values.testDate = Number(values.testDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...patientOrganismAntibioticSusceptibilityEntity,
      ...values,
      patientLabTestItem: userLabTestItems.find(it => it.id.toString() === values.patientLabTestItem?.toString()),
      organism: organisms.find(it => it.id.toString() === values.organism?.toString()),
      antibiotic: antibiotics.find(it => it.id.toString() === values.antibiotic?.toString()),
      sensitivity: clinicalDictionaries.find(it => it.id.toString() === values.sensitivity?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientOrganismAntibioticSusceptibilityEntity,
          patientLabTestItem: patientOrganismAntibioticSusceptibilityEntity?.patientLabTestItem?.id,
          organism: patientOrganismAntibioticSusceptibilityEntity?.organism?.id,
          antibiotic: patientOrganismAntibioticSusceptibilityEntity?.antibiotic?.id,
          sensitivity: patientOrganismAntibioticSusceptibilityEntity?.sensitivity?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.createOrEditLabel"
            data-cy="PatientOrganismAntibioticSusceptibilityCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.createOrEditLabel">
              Create or edit a PatientOrganismAntibioticSusceptibility
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-organism-antibiotic-susceptibility-id"
                  label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.zoneOfInhibition')}
                id="patient-organism-antibiotic-susceptibility-zoneOfInhibition"
                name="zoneOfInhibition"
                data-cy="zoneOfInhibition"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.mic')}
                id="patient-organism-antibiotic-susceptibility-mic"
                name="mic"
                data-cy="mic"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.mbc')}
                id="patient-organism-antibiotic-susceptibility-mbc"
                name="mbc"
                data-cy="mbc"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.testDate')}
                id="patient-organism-antibiotic-susceptibility-testDate"
                name="testDate"
                data-cy="testDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.virulenceFactors')}
                id="patient-organism-antibiotic-susceptibility-virulenceFactors"
                name="virulenceFactors"
                data-cy="virulenceFactors"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.resistanceMechanisms')}
                id="patient-organism-antibiotic-susceptibility-resistanceMechanisms"
                name="resistanceMechanisms"
                data-cy="resistanceMechanisms"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.morphology')}
                id="patient-organism-antibiotic-susceptibility-morphology"
                name="morphology"
                data-cy="morphology"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.growthConditions')}
                id="patient-organism-antibiotic-susceptibility-growthConditions"
                name="growthConditions"
                data-cy="growthConditions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.notes')}
                id="patient-organism-antibiotic-susceptibility-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.active')}
                id="patient-organism-antibiotic-susceptibility-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.cursor')}
                id="patient-organism-antibiotic-susceptibility-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.lastUpdated')}
                id="patient-organism-antibiotic-susceptibility-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.microSec')}
                id="patient-organism-antibiotic-susceptibility-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.timestampEntry')}
                id="patient-organism-antibiotic-susceptibility-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.recommended')}
                id="patient-organism-antibiotic-susceptibility-recommended"
                name="recommended"
                data-cy="recommended"
                check
                type="checkbox"
              />
              <ValidatedField
                id="patient-organism-antibiotic-susceptibility-patientLabTestItem"
                name="patientLabTestItem"
                data-cy="patientLabTestItem"
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.patientLabTestItem')}
                type="select"
              >
                <option value="" key="0" />
                {userLabTestItems
                  ? userLabTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-organism-antibiotic-susceptibility-organism"
                name="organism"
                data-cy="organism"
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.organism')}
                type="select"
              >
                <option value="" key="0" />
                {organisms
                  ? organisms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-organism-antibiotic-susceptibility-antibiotic"
                name="antibiotic"
                data-cy="antibiotic"
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.antibiotic')}
                type="select"
              >
                <option value="" key="0" />
                {antibiotics
                  ? antibiotics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-organism-antibiotic-susceptibility-sensitivity"
                name="sensitivity"
                data-cy="sensitivity"
                label={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.sensitivity')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/patient-organism-antibiotic-susceptibility"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientOrganismAntibioticSusceptibilityUpdate;
